import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHealthProviderTranslationsDocument,
  GetHealthProviderTranslationsQueryVariables,
  HealthProviderTranslationItemDataFragment,
} from '../../types/api/graphql';

export function useHealthProviderTranslationItems(
  variables: GetHealthProviderTranslationsQueryVariables,
  skip?: boolean
) {
  const {
    data: healthProviderTranslationItemsData,
    loading: healthProviderTranslationItemsLoading,
  } = useCacheQuery(GetHealthProviderTranslationsDocument, {
    variables: {
      ...variables,
    },
    skip: skip === true || !variables.healthProviderId,
  });

  const data = useMemo(
    () =>
      healthProviderTranslationItemsData?.translations ??
      ([] as HealthProviderTranslationItemDataFragment[]),
    [healthProviderTranslationItemsData?.translations]
  );

  return {
    data,
    loading: healthProviderTranslationItemsLoading,
  };
}
